import {
  ADD_LEGACY_APPS_FAVORITE,
  App,
  GET_ALL_LEGACY_APPS,
  GET_LEGACY_APPS_FAVORITES,
  REMOVE_LEGACY_APPS_FAVORITE,
  REORDER_LEGACY_APPS_FAVORITES,
} from '@/rtk-query.gql';

import { enhancedApi } from '../api/baseApi';
import { RootState, store } from '../store';

const ALL_REGIONS_ENVIRONMENT_ID = 999;

export const legacyAppsApi = enhancedApi.injectEndpoints({
  endpoints: (build) => ({
    getLegacyApps: build.query({
      query: () => ({
        document: GET_ALL_LEGACY_APPS,
      }),
      transformResponse: (response: { apps: App[] }) => {
        const state = store.getState() as RootState;
        const environmentId =
          state.authentication.me?.environmentId === 9999
            ? 0
            : state.authentication.me?.environmentId;

        if (environmentId === undefined || environmentId === null) {
          return response.apps;
        }

        return response.apps.filter(
          (app) =>
            app.environmentId === environmentId ||
            app.environmentId === ALL_REGIONS_ENVIRONMENT_ID,
        );
      },
      providesTags: ['LegacyApps'],
    }),
    getLegacyAppsFavorites: build.query({
      query: () => ({
        document: GET_LEGACY_APPS_FAVORITES,
      }),
      transformResponse: (response: { appsFavorites: string[] }) =>
        response.appsFavorites,
      providesTags: ['LegacyAppsFavorites'],
    }),
    addLegacyAppFavorite: build.mutation({
      query: (variables) => ({
        document: ADD_LEGACY_APPS_FAVORITE,
        variables,
      }),
      invalidatesTags: ['LegacyAppsFavorites'],
    }),
    removeLegacyAppFavorite: build.mutation({
      query: (variables) => ({
        document: REMOVE_LEGACY_APPS_FAVORITE,
        variables,
      }),
      invalidatesTags: ['LegacyAppsFavorites'],
    }),
    reorderLegacyAppsFavorites: build.mutation({
      query: (variables) => ({
        document: REORDER_LEGACY_APPS_FAVORITES,
        variables,
      }),
      invalidatesTags: ['LegacyAppsFavorites'],
    }),
  }),
});

export const {
  useAddLegacyAppFavoriteMutation,
  useGetLegacyAppsFavoritesQuery,
  useGetLegacyAppsQuery,
  useLazyGetLegacyAppsFavoritesQuery,
  useLazyGetLegacyAppsQuery,
  useRemoveLegacyAppFavoriteMutation,
  useReorderLegacyAppsFavoritesMutation,
} = legacyAppsApi;
